import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as libraryActions from '~/library/actions';
import * as navActions from '~/sidebarNav/actions';
import LibraryViewVersionEvidence from '~/library/components/LibraryViewVersionEvidence';
import LibraryViewTabSection from '~/library/components/LibraryViewTabSection';
import LibraryViewVersionVulnerabilities from '~/library/containers/LibraryViewVersionVulnerabilities';
import LibraryViewVersionLicenses from '~/library/containers/LibraryViewVersionLicenses';
import LibraryViewVulnerabilities from '~/library/containers/LibraryViewVulnerabilities';
import LibraryViewReleases from '~/library/containers/LibraryViewReleases';
import LibraryViewCommitHashVulnerabilities from '~/library/containers/LibraryViewCommitHashVulnerabilities';
type LibraryViewProps = {
  libraryState: object;
  actions: object;
};
class LibraryView extends React.Component<LibraryViewProps, {}> {
  constructor(props, context) {
    super(props, context);
  }
  render() {
    const { libraryState } = this.props;
    const { tab } = libraryState;
    let bodyElementLookup;
    let bodyElement;
    const headerTextClassName =
      'pb mb bo--1 bo-rad--3 border-color--white-dark bg-color--white-light font--16 text--bold color--black-light p text--';
    if (tab === 'versions') {
      bodyElement = (
        <div>
          <div className="bo-b--1 border-color--white-dark mb">
            <div className={headerTextClassName}>Vulnerabilities</div>
            <LibraryViewVersionVulnerabilities libraryState={libraryState} />
          </div>
          <div className="bo-b--1 border-color--white-dark mb">
            <div className={headerTextClassName}>Licenses</div>
            <LibraryViewVersionLicenses libraryState={libraryState} />
          </div>
          <div className="bo-b--1 border-color--white-dark">
            <div className={headerTextClassName}>Evidence</div>
            <LibraryViewVersionEvidence libraryState={libraryState} />
          </div>
        </div>
      );
    } else if (tab === 'commit_hash') {
      bodyElement = (
        <div>
          <div className="bo-b--1 border-color--white-dark mb">
            <div className={headerTextClassName}>Vulnerabilities</div>
            <LibraryViewCommitHashVulnerabilities libraryState={libraryState} />
          </div>
          <div className="bo-b--1 border-color--white-dark mb">
            <div className={headerTextClassName}>Licenses</div>
            <LibraryViewVersionLicenses libraryState={libraryState} />
          </div>
          <div className="bo-b--1 border-color--white-dark">
            <div className={headerTextClassName}>Evidence</div>
            <LibraryViewVersionEvidence libraryState={libraryState} />
          </div>
        </div>
      );
    } else {
      bodyElementLookup = {
        summary: (
          <div>
            <div className="bo-b--1 border-color--white-dark mb">
              <div className={headerTextClassName}>Vulnerability History</div>
              <LibraryViewVulnerabilities libraryState={libraryState} />
            </div>
            <div className="bo-b--1 border-color--white-dark">
              <div className={headerTextClassName}>Release History</div>
              <LibraryViewReleases libraryState={libraryState} />
            </div>
          </div>
        ),
      };
      bodyElement = bodyElementLookup[tab];
    }
    return (
      <div className="grid">
        <div className="grid__item col-1-1">
          <LibraryViewTabSection libraryState={libraryState} />
        </div>

        <div className="grid__item col-1-1 pt">{bodyElement}</div>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    libraryState: state.libraryState,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Object.assign({}, libraryActions, navActions), dispatch),
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LibraryView);
